export default __webpack_public_path__ + "static/MediaMainBanner-7b4626eaa69c42387896a585bc0ab5aa.webp";